import type { TourAudienceCriteria } from "./types";

export interface ReachResult {
  reachable: boolean;
  reason?: string;
}

function disjoint(a: string[] | undefined, b: string[] | undefined): boolean {
  if (!a || !b || a.length === 0 || b.length === 0) return false;
  return !a.some((x) => b.includes(x));
}

export function isStepReachable(
  step: TourAudienceCriteria | null | undefined,
  audience: TourAudienceCriteria | null | undefined,
): ReachResult {
  const s: TourAudienceCriteria = step ?? {};
  const a: TourAudienceCriteria = audience ?? {};

  if (disjoint(s.roles, a.roles)) {
    return {
      reachable: false,
      reason: "Step roles don't overlap with the tour audience's roles — no user will see this step.",
    };
  }

  if (disjoint(s.locations, a.locations)) {
    return {
      reachable: false,
      reason: "Step locations don't overlap with the tour audience's locations — no user will see this step.",
    };
  }

  const sOnboard = s.onboardingState && s.onboardingState !== "any" ? s.onboardingState : null;
  const aOnboard = a.onboardingState && a.onboardingState !== "any" ? a.onboardingState : null;
  if (sOnboard && aOnboard && sOnboard !== aOnboard) {
    return {
      reachable: false,
      reason: `Step requires onboarding state "${sOnboard}" but the audience requires "${aOnboard}".`,
    };
  }

  return { reachable: true };
}
